export const GET_LABTESTSAMPLE_FOR_ORDER = "GET_LABTESTSAMPLE_FOR_ORDER";
export const SET_ACTIVE_LABTESTSAMPLE = "SET_ACTIVE_LABTESTSAMPLE";
export const POST_LABTESTSAMPLE = "POST_LABTESTSAMPLE";
export const GET_SAMPLE_BY_UUID = "GET_SAMPLE_BY_UUID";
export const EDIT_LABTESTSAMPLE = "EDIT_LABTESTSAMPLE"